import React, { useState } from "react";
import Link from "next/link";
import { IconContext } from "react-icons";
import { MdMenu, MdClose } from "react-icons/md";
import SideNavBar from "../SideNavbar";
import Container from "./styles";

const Header = (props) => {
    const [showMenu, setShowMenu] = useState(false);

    /* Omitir o target se for um link interno */
    const arrSortedMenuLinks = [
        {
            text: "Sou Fotógrafo",
            href: "https://fotop.io",
            target: "_blank",
        },
        {
            text: "Business",
            href: "/business",
            target: "",
        },
        {
            text: "Login",
            href: "/login",
            target: "",
        },
        {
            text: "Contato",
            href: "https://fotop.com/fotos/r/WPSWv0",
            target: "_blank",
        },
    ];

    return (
        <>
            <Container>
                <div className="container">
                    <div className="container-logo">
                        <Link href="/">
                            <a className="logo">
                                <img src="/images/fotop-servicos-01.svg" />
                            </a>
                        </Link>
                        {props.logoPartner === "digipix" ? (
                            <Link href="/">
                                <a className="logo-partner">
                                    <img src="/images/digipix_partner.svg" />
                                </a>
                            </Link>
                        ) : props.logoPartner === "tray" ? (
                            <Link href="/">
                                <a className="logo-partner">
                                    <img src="/images/tray_partner.svg" />
                                </a>
                            </Link>
                        ) : props.logoPartner === "olx" ? (
                            <Link href="/">
                                <a className="logo-partner">
                                    <img src="/images/olx_partner.svg" />
                                </a>
                            </Link>
                        ) : props.logoPartner === "conectala" ? (
                            <Link href="/">
                                <a className="logo-partner">
                                    <img src="/images/conectala_partner.png" />
                                </a>
                            </Link>
                        ) : null}
                    </div>
                    <div className="menu">
                        <ul>
                            {arrSortedMenuLinks.map((item, index) => (
                                <li key={index}>
                                    {item.target ? (
                                        <a href={item.href} target={item.target}>
                                            {item.text}
                                        </a>
                                    ) : (
                                        <Link href={item.href}>
                                            <a>{item.text}</a>
                                        </Link>
                                    )}
                                </li>
                            ))}
                        </ul>
                    </div>
                    <div className="container menu-mobile">
                        <button className="icon-menu" onClick={async () => setShowMenu(!showMenu)}>
                            <IconContext.Provider value={{ size: "22px" }}>
                                {showMenu ? <MdClose color="white" /> : <MdMenu color="white" />}
                            </IconContext.Provider>
                        </button>
                    </div>
                </div>
            </Container>
            <SideNavBar
                items={[
                    {
                        item: "Contato",
                        url: "https://fotop.com/fotos/r/WPSWv0",
                        isLinkOut: true,
                    },
                    {
                        item: "Business",
                        url: "http://business.fotografoja.com/",
                        isLinkOut: true,
                    },
                    { item: "Fotógrafo", url: "https://fotop.io/", isLinkOut: true },
                    {
                        item: "Login",
                        url: "/login",
                        isLinkOut: false,
                    },
                ]}
                isVisible={showMenu}
                setShowMenu={setShowMenu}
            />
        </>
    );
};

export default Header;
